var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 20.6894L16.0859 15.0254C17.447 13.3914 18.1257 11.2956 17.9808 9.17395C17.836 7.05231 16.8788 5.06819 15.3083 3.63434C13.7378 2.20048 11.675 1.42729 9.549 1.4756C7.42298 1.52391 5.39742 2.39001 3.89371 3.89372C2.39 5.39744 1.5239 7.42299 1.47558 9.54902C1.42727 11.675 2.20047 13.7378 3.63432 15.3083C5.06818 16.8788 7.0523 17.836 9.17393 17.9808C11.2956 18.1257 13.3914 17.447 15.0253 16.0859L20.6894 21.75L21.75 20.6894ZM2.99999 9.75001C2.99999 8.41499 3.39588 7.10994 4.13757 5.99991C4.87927 4.88988 5.93348 4.02471 7.16688 3.51382C8.40028 3.00293 9.75748 2.86926 11.0669 3.12971C12.3762 3.39016 13.579 4.03303 14.523 4.97704C15.467 5.92104 16.1098 7.12378 16.3703 8.43315C16.6307 9.74252 16.4971 11.0997 15.9862 12.3331C15.4753 13.5665 14.6101 14.6207 13.5001 15.3624C12.3901 16.1041 11.085 16.5 9.74999 16.5C7.96039 16.498 6.24466 15.7862 4.97922 14.5208C3.71378 13.2553 3.00198 11.5396 2.99999 9.75001Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic-search.964e90d68147a9f80aea6272916f62a3.svg";
export { ForwardRef as ReactComponent };